import Input from "../components/element/Input";
import Button from "../components/element/Button";
import React from "react";
import EntityApi from "../api/EntityApi";
import Modal from "../components/main/Modal";

const ContentModal = ({onSuccess, parentId, productId}) => {

    const [chapterName, setChapterName] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);

    const add = () => {
        if (chapterName == '') {
            alert('Пустое название');
        } else if (!isLoading) {
            setIsLoading(true);
            EntityApi.put('private/chapter', {
                title: chapterName,
                description: "",
                parent: parentId,
                product: productId
            }).then((data) => {
                setIsLoading(false);
                onSuccess();
                setChapterName('');
            }).catch(() => {
                setIsLoading(false);
            })
        }
    }

    return <div className={"w-80"}>
        <Input onChange={setChapterName} placeholder={'Введите название главы'} type={'text'} value={chapterName}/>
        <div className="mt-6"></div>
        <Button text={"Добавить"} type={isLoading ? 'default' : 'primary'} onClick={add}/>
    </div>
}

const ChapterFormModal = ({isOpen, onClose, onSuccess, parentId, productId}) => {

    const title = parentId > 0 ? 'подглаву' : 'главу';
    const onSuccessRequest = () => {
        if (onSuccess) {
            onSuccess();
        }
        onClose();
    }

    return <Modal title={"Добавить " + title} component={<ContentModal onSuccess={onSuccessRequest} productId={productId} parentId={parentId} />} isOpen={isOpen} onClose={onClose}/>
}

export default ChapterFormModal;
